import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Modal,
  Table,
  Badge,
  InputGroup,
  Spinner,
  FormControl,
} from "react-bootstrap";
import axiosInstance from '../../api/axios';
import { toast } from "react-toastify";
import { Trash, Pencil, Plus, Search } from "react-bootstrap-icons";
import Header from "../../layouts/Header";
import { useSelector } from "react-redux";

const RawMaterialMainCategory = () => {
  const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
  const [skin, setSkin] = useState(currentSkin);
  const accessToken = localStorage.getItem("authToken");
  const { access } = useSelector((state) => state.login);
  const { email } = useSelector((state) => state.login);
  const [materialAccess, setMaterialAccess] = useState([]);

  console.log("Access :", access);

  useEffect(() => {
      if (Array.isArray(access)) {
          const filteredAccess = access?.filter((perm) =>
            perm?.startsWith("RmMainCategory:")
          );
          setMaterialAccess(filteredAccess);
      }
  }, [access]);

  console.log("Material Access:", materialAccess);

  // State for data
  const [mainCategories, setMainCategories] = useState([]);
  const [filteredMainCategories, setFilteredMainCategories] = useState([]);

  // State for forms
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  const [editFormData, setEditFormData] = useState({
    id: "",
    name: "",
    description: "",
  });

  // State for UI
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);

  // State for filters and pagination
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  // API Calls
  const getMainCategories = async () => {
    try {
      setIsLoading(true);
      const headers = { Authorization: `Bearer ${accessToken}` };
      const response = await axiosInstance.get("masters/rm-main-category/get", { headers });
      
      if (response?.data?.status === true) {
        setMainCategories(response.data.data.categories);
        setFilteredMainCategories(response.data.data.categories);
      }
    } catch (error) {
      handleApiError(error, "Failed to fetch main categories");
    } finally {
      setIsLoading(false);
    }
  };

  const addMainCategory = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const headers = { Authorization: `Bearer ${accessToken}` };
      const response = await axiosInstance.post(
        "masters/rm-main-category/add",
        formData,
        { headers }
      );
  
      if (response?.data?.status === true) {
        toast.success(response.data.data.message);
        getMainCategories();
        resetForm();
        setShowAddModal(false);
      }
    } catch (error) {
      handleApiError(error, "Failed to add main category");
    } finally {
      setIsLoading(false);
    }
  };

  const updateMainCategory = async (e) => {
    e.preventDefault();
    try {
      setIsEditLoading(true);
      const headers = { Authorization: `Bearer ${accessToken}` };
      const response = await axiosInstance.put(
        "masters/rm-main-category/update",
        editFormData,
        { headers }
      );
      
      if (response?.data?.status === true) {
        toast.success(response.data.data.message);
        getMainCategories();
        setShowEditModal(false);
      }
    } catch (error) {
      handleApiError(error, "Failed to update main category");
    } finally {
      setIsEditLoading(false);
    }
  };

  const deleteMainCategory = async () => {
    try {
      setIsDeleteLoading(true);
      const headers = { Authorization: `Bearer ${accessToken}` };
      const response = await axiosInstance.delete(
        `masters/rm-main-category/delete?id=${editFormData.id}`,
        { headers }
      );
      
      if (response?.data?.status === true) {
        toast.success(response.data.data.message);
        getMainCategories();
        setShowDeleteModal(false);
      }
    } catch (error) {
      handleApiError(error, "Failed to delete main category");
    } finally {
      setIsDeleteLoading(false);
    }
  };

  // Helper functions
  const handleApiError = (error, defaultMessage) => {
    let errorMessage = defaultMessage;
    
    if (error?.response) {
      if (error.response.status === 400) {
        errorMessage = error.response.data.message || error.response.data.title;
      } else if (error.response.status === 403) {
        errorMessage = error.response.data.message || "Forbidden";
      } else if (error.response.status === 404) {
        errorMessage = error.response.data.message || "Resource not found";
      } else if (error.response.status === 406) {
        errorMessage = error.response.data.error?.message || error.response.data.error;
      } else if (error.response.status === 412) {
        errorMessage = error.response.data.data?.message || error.response.data.error;
      } else if (error.response.status === 500) {
        errorMessage = error.response.data.error || "Server error";
      }
    }
    
    toast.error(errorMessage);
  };

  const resetForm = () => {
    setFormData({
      name: "",
      description: "",
    });
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleEditMainCategory = (category) => {
    setEditFormData({
      id: category._id,
      name: category.name,
      description: category.description,
    });
    setShowEditModal(true);
  };

  const handleDeleteMainCategory = (category) => {
    setEditFormData({
      id: category._id,
      name: category.name
    });
    setShowDeleteModal(true);
  };

  // Initialize data
  useEffect(() => {
    getMainCategories();
  }, []);

  // Filter main categories based on search term
  useEffect(() => {
    if (searchTerm) {
      const filtered = mainCategories.filter(item => 
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.description.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredMainCategories(filtered);
    } else {
      setFilteredMainCategories(mainCategories);
    }
    setCurrentPage(1);
  }, [searchTerm, mainCategories]);

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredMainCategories.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredMainCategories.length / itemsPerPage);

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className={`main main-app p-3 p-lg-4 ${skin === 'dark' ? 'bg-dark text-white' : 'bg-light'}`}>
        <Container fluid className="bg-white">
          {/* Header and Filters */}
          <Row className="mb-4 pt-2 align-items-center">
            <Col className="d-flex" lg={7}>
              <h4 className="mb-0 fw-semibold">RAW MATERIAL MAIN CATEGORIES</h4>
              <span className="text-muted ms-2">(Manage your raw material main categories).</span>
            </Col>
            <Col className="d-flex justify-content-end">
              {(materialAccess?.includes("RmMainCategory:add") || email === 'contact@xpansecafe.com') && (
                <Button 
                  variant="primary" 
                  onClick={() => setShowAddModal(true)}
                  className="d-flex align-items-center"
                >
                  <Plus className="me-2" /> Add New Main Category
                </Button>
              )}
            </Col>
            <hr className="mt-2 mb-0" />
          </Row>

          <Row className="mb-4">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text>
                  <Search />
                </InputGroup.Text>
                <FormControl
                  placeholder="Search main categories..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </InputGroup>
            </Col>
          </Row>

          {/* Main Categories Table */}
          <Row>
            <Col>
              {isLoading ? (
                <div className="text-center py-5">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : (
                <>
                  <div className="table-responsive">
                    {(materialAccess?.includes("RmMainCategory:get") || email === 'contact@xpansecafe.com') && (
                      <Table striped bordered hover>
                        <thead className="bg-black text-white">
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Description</th>
                              {((materialAccess.includes("RmMainCategory:update") || materialAccess.includes("RmMainCategory:delete")) || email === "contact@xpansecafe.com") && (
                              <th>Actions</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems.length > 0 ? (
                            currentItems.map((category, index) => (
                              <tr key={category._id}>
                                <td>{indexOfFirstItem + index + 1}</td>
                                <td className="w-25">{category.name}</td>
                                <td style={{ fontSize: '12px' }}>{category.description || '-'}</td>
                                {((materialAccess.includes("RmMainCategory:update") || materialAccess.includes("RmMainCategory:delete")) || email === "contact@xpansecafe.com") && (
                                  <td>
                                    <div className="d-flex">
                                      {(materialAccess?.includes("RmMainCategory:update") || email === 'contact@xpansecafe.com') && (
                                        <Button 
                                          variant="outline-primary"
                                          size="sm" 
                                          className="me-2"
                                          onClick={() => handleEditMainCategory(category)}
                                        >
                                          <Pencil />
                                        </Button>
                                      )}
                                      {(materialAccess?.includes("RmMainCategory:delete") || email === 'contact@xpansecafe.com') && (
                                        <Button 
                                          variant="outline-danger" 
                                          size="sm"
                                          onClick={() => handleDeleteMainCategory(category)}
                                        >
                                          <Trash />
                                        </Button>
                                      )}
                                    </div>
                                  </td>
                                )}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">No main categories found</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    )}
                  </div>

                  {/* Pagination */}
                  {filteredMainCategories.length > itemsPerPage && (
                    <div className="d-flex justify-content-between align-items-center mt-1 pb-2">
                        <div>
                            Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredMainCategories.length)} of {filteredMainCategories.length} entries
                        </div>
                        <div>
                            <Button 
                            variant="outline-secondary" 
                            size="sm" 
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage(currentPage - 1)}
                            className="me-2"
                            >
                            Previous
                            </Button>
                            <Button 
                            variant="outline-secondary" 
                            size="sm" 
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage(currentPage + 1)}
                            >
                            Next
                            </Button>
                        </div>
                    </div>
                  )}
                </>
              )}
            </Col>
          </Row>

            {/* Add Main Category Modal */}
            <Modal show={showAddModal} onHide={() => setShowAddModal(false)} size="lg">
                <Modal.Header closeButton>
                <Modal.Title>Add New Main Category</Modal.Title>
                </Modal.Header>
                <Form onSubmit={addMainCategory}>
                <Modal.Body>
                    <Form.Group className="mb-3">
                    <Form.Label>Name <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleFormChange}
                        placeholder="Enter main category name"
                        required
                    />
                    </Form.Group>

                    <Form.Group className="mb-3">
                    <Form.Label>Description <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={4}
                        name="description"
                        value={formData.description}
                        onChange={handleFormChange}
                        placeholder="Enter description"
                        required
                    />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowAddModal(false)}>
                    Cancel
                    </Button>
                    <Button variant="warning" type="submit" disabled={isLoading}>
                    {isLoading ? (
                        <>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        <span className="ms-2">Adding...</span>
                        </>
                    ) : (
                        "Add Main Category"
                    )}
                    </Button>
                </Modal.Footer>
                </Form>
            </Modal>

          {/* Edit Main Category Modal */}
          <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Edit Main Category</Modal.Title>
            </Modal.Header>
            <Form onSubmit={updateMainCategory}>
              <Modal.Body>
                <Form.Group className="mb-3">
                  <Form.Label>Name <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={editFormData.name}
                    onChange={handleEditFormChange}
                    placeholder="Enter main category name"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Description <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="description"
                    value={editFormData.description}
                    onChange={handleEditFormChange}
                    placeholder="Enter description"
                    required
                  />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                  Cancel
                </Button>
                <Button variant="primary" type="submit" disabled={isEditLoading}>
                  {isEditLoading ? (
                    <>
                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                      <span className="ms-2">Saving...</span>
                    </>
                  ) : (
                    "Save Changes"
                  )}
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>

            {/* Delete Confirmation Modal */}
            {/* <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete the main category <strong>{editFormData.name}</strong>? This action cannot be undone.
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={deleteMainCategory} disabled={isDeleteLoading}>
                    {isDeleteLoading ? (
                    <>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        <span className="ms-2">Deleting...</span>
                    </>
                    ) : (
                    "Delete"
                    )}
                </Button>
                </Modal.Footer>
            </Modal> */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title className='text-danger'>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete the main category <strong>{editFormData.name}</strong>? This action cannot be undone.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={deleteMainCategory}>
                        { isDeleteLoading ?
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            /> :
                                "Delete Category"                                
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default RawMaterialMainCategory;